var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Checkbox',{on:{"input":_vm.changeIsRequired},model:{value:(_vm.isRequired),callback:function ($$v) {_vm.isRequired=$$v},expression:"isRequired"}},[_vm._v("Required")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }